export const ComponentConstants = {
  Workflow: {
    ArchiveQueue: 'WorkflowArchiveQueue'
  }
};
